import styled from 'styled-components'

export const StyledGroundInformation = styled.div`
  padding: 5px 3rem;

  border-radius: 3px;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 15%), 2px 2px 2px rgb(0 0 0 / 25%);
  margin: 5px 0 30px 0;
  display: block;
  background-color: white;
  font-size: 14px;

  label:first-of-type {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    cursor: pointer;
  }

  span {
    line-height: 30px;
  }

  svg {
    fill: ${({ theme }) => theme.colors.primary};
    vertical-align: text-bottom;
    margin-right: 5px;
  }

  > .row {
    padding-bottom: 12px;

    .left-field,
    .right-field {
      padding: 0;
    }
  }

  .warning-label {
    font-weight: normal;
    color: red;
  }
  .vehicle-cost {
    /* font-size: 1.4em; */
    text-align: center;
    max-width: fit-content;
    padding: 5px 15px;
  }

  .condition-tag {
    padding: 6px 15px;
    margin-left: 15px;
  }

  @media (max-width: 500px) {
    .price-tag {
      margin-top: 10px;
    }
  }

  .alert-info {
    color: black;
    font-weight: bold;
  }
`

export const StyledVehicleDetailText = styled.div`
  color: ${({ theme }) => theme.colors.defaultTextColor};

  span {
    font-weight: 600;
  }

  a {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    cursor: pointer;
  }
`

export const StyledVehicleDetailDivider = styled.div`
  align-items: center;
  cursor: pointer;
  padding: 8px 0;

  label {
    white-space: nowrap;
  }
`
